import { Pipe, PipeTransform } from '@angular/core';
import { Name } from 'libs/shared/model/src/lib/types/name.type';

@Pipe({
  name: 'initials',
  standalone: true,
})
export class InitialsPipe implements PipeTransform {
  public transform(name: Name): string {
    if (!name) {
      return '';
    }

    const firstInitial = name.firstName ? name.firstName.charAt(0).toUpperCase() : '';
    const lastInitial = name.lastName ? name.lastName.charAt(0).toUpperCase() : '';

    return `${firstInitial}${lastInitial}`;
  }
}
